/**
 * Validates if the input value is a valid numeric input (allows typing decimal numbers)
 * Allows: empty string, minus sign, digits, comma, and dot
 * Examples: "", "-", "0", "0.", "0.5", "0,5", "-123.45"
 */
export const isValidNumericInput = (value: string): boolean => {
    return value === '' || value === '-' || /^-?\d*[.,]?\d*$/.test(value);
};

/**
 * Converts comma to dot in numeric strings for API submission
 * Example: "0,5" -> "0.5"
 */
export const normalizeDecimalSeparator = (value: string | number | null | undefined): string | number | null => {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    return String(value).replace(',', '.');
};

/**
 * Checks if a field type is numeric
 */
export const isNumericFieldType = (type: string): boolean => {
    return type === 'float' || type === 'number' || type === 'decimal' || isIntegerFieldType(type);
};

/**
 * Whole numbers only - they get the plain numeric keypad and reject a separator,
 * where a decimal field has to accept one.
 */
export const isIntegerFieldType = (type: string): boolean => {
    return type === 'integer';
};

/** Allows: empty string, minus sign, digits. Examples: "", "-", "0", "-12" */
export const isValidIntegerInput = (value: string): boolean => {
    return value === '' || value === '-' || /^-?\d+$/.test(value);
};
